import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../features/Cart/useCart";
import { useCartItem } from "../../features/Cart/useCartItem";
import { useAuthStore } from "../../store/authStore";
import QuantitySelector from "./QuantitySelector";
import Button from "../Button";

const AddToCartButton = ({ product }) => {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const CART_ENABLED = process.env.REACT_APP_CART_ENABLED;

  const {
    addToCart,
    updateQuantity,
    removeItem,
    validateCart
  } = useCart({
    enabled: isAuthenticated,
  });

  const cartItem = useCartItem(product.id);
  const [quantity, setQuantity] = useState(cartItem?.quantity || 1);

  const goToLogin = () => {
    navigate("/user-login/");
  };

  const handleAdd = async () => {
    // if (CART_ENABLED) {
    //   alert("افزودن به سبد خرید به‌زودی فعال می‌شود.");
    //   return;
    // }

    if (!isAuthenticated) {
      goToLogin();
      return;
    }

    try {
      await addToCart.mutateAsync({
        productId: product.id,
        quantity: 1,
      });
    } catch (error) {
      console.error("Add to cart failed:", error);

      if (error.response?.status === 401) {
        goToLogin();
      }
    }
  };

  const handleQuantityChange = async (q) => {
    if (!isAuthenticated) {
      goToLogin();
      return;
    }

    if (!cartItem) return;

    setQuantity(q);

    try {
      await updateQuantity.mutateAsync({
        itemId: cartItem.id,
        quantity: q,
      });
      validateCart.mutate();
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };

  const handleRemove = async () => {
    if (!isAuthenticated) {
      goToLogin();
      return;
    }

    if (!cartItem) return;

    try {
      await removeItem.mutateAsync(cartItem.id);
      validateCart.mutate();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };

  if (!isAuthenticated) {
    return (
      <Button onClick={goToLogin}>
        ورود و افزودن به سبد
      </Button>
    );
  }

  if (!cartItem) {
    return (
      <Button
        onClick={handleAdd}
        disabled={addToCart.isPending || addToCart.isLoading}
      >
        {addToCart.isPending || addToCart.isLoading
          ? "در حال افزودن..."
          : "افزودن به سبد"}
      </Button>
    );
  }

  return (
    <QuantitySelector
      value={cartItem.quantity}
      onChange={handleQuantityChange}
      onRemove={handleRemove}
      showRemoveButton
      min={cartItem.min_order}
      max={cartItem.max_order}
      multiple={cartItem.order_multiple}
    />
  );
};

export default AddToCartButton;
